import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=2afe833a&scoped=true"
import script from "./dropdown.vue?vue&type=script&lang=js"
export * from "./dropdown.vue?vue&type=script&lang=js"
import style0 from "./dropdown.vue?vue&type=style&index=0&id=2afe833a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe833a",
  null
  
)

export default component.exports